import { render, staticRenderFns } from "./BreakList.vue?vue&type=template&id=4ddf329e&scoped=true"
import script from "./BreakList.vue?vue&type=script&lang=js"
export * from "./BreakList.vue?vue&type=script&lang=js"
import style0 from "./BreakList.vue?vue&type=style&index=0&id=4ddf329e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddf329e",
  null
  
)

export default component.exports